module.exports = __webpack_public_path__ + "img/find-more.ad284e99.svg";